import { render, staticRenderFns } from "./ChecklistProposta.vue?vue&type=template&id=71b7d395"
import script from "./ChecklistProposta.vue?vue&type=script&lang=js"
export * from "./ChecklistProposta.vue?vue&type=script&lang=js"
import style0 from "./ChecklistProposta.vue?vue&type=style&index=0&id=71b7d395&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports